export const mapError = (error, containerError) => {
  Object.keys(error).forEach(element => {
    containerError[element] = error[element]
  })
  return containerError
}

export const errorMessage = {
  401: { title: `Internal Error`, message: `You're Not Authorized` },
  403: { title: `Forbidden`, message: `This action is forbidden` },
  404: { title: `Not Found`, message: `Not Found` },
  500: { title: `Internal Server Error`, message: `Internal Server Error` },
  503: { title: `No Internet`, message: `No Internet Connection` },
  400: ({ data }) => { return data.error }
}

export const parseErrorGql = (error) => {
  if (Array.isArray(error)) {
    let latestErrorCode = 500
    const errors = error.map(err => {
      const { message } = err
      const split = message.replace(/\s/g, '').split(':')
      if (split.length > 2) {
        const errorCode = parseInt(split.pop())
        latestErrorCode = errorCode
        return {
          ...err,
          code: errorCode
        }
      }
      return { ...err, code: 500 }
    })
    return {
      errors: errors,
      hasError: true,
      code: latestErrorCode
    }
  } else {
    const { message } = error
    const split = message.replace(/\s/g, '').split(':')
    if (split.length > 2) {
      return {
        ...error,
        code: parseInt(split.pop())
      }
    }
    return { errors: error, hasError: true, code: 500 }
  }
}

export default {
  mapError,
  errorMessage,
  parseErrorGql
}
